import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ModuleType } from '../_models/module-types';

@Injectable({
  providedIn: 'root',
})
export class CsvService {
  private readonly http = inject(HttpClient);

  downloadModuleCsv(
    moduleType: ModuleType,
    experimentId: number,
    isExtended: boolean = false,
  ): Observable<void> {
    let params = new HttpParams();
    params = params.set('isExtended', isExtended.toString());

    return this.http
      .get(
        `${environment.apiUrl}/${moduleType}-module/${experimentId}/download-experiment-data`,
        {
          params,
          responseType: 'blob',
          observe: 'response',
        },
      )
      .pipe(
        switchMap((response) => {
          if (!response.body) {
            return throwError(() => ({ status: -1, message: 'No data received for CSV download', code: null }));
          }
          const blob = new Blob([response.body], { type: 'text/csv' });
          const filename =
            this.getFilenameFromHeader(response.headers) || 'data-export.csv';
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          link.click();
          URL.revokeObjectURL(url);
          return of(undefined);
        }),
      );
  }

  downloadFluoroModuleCsv(
    type: string,
    experimentId: number,
  ): Observable<void> {
    return this.http
      .get(
        `${environment.apiUrl}/fluorescence-module/${experimentId}/${type}/download`,
        {
          responseType: 'blob',
          observe: 'response',
        },
      )
      .pipe(
        switchMap((response) => {
          if (!response.body) {
            return throwError(() => ({ status: -1, message: 'No data received for CSV download', code: null }));
          }
          const blob = new Blob([response.body], { type: 'text/csv' });
          const filename =
            this.getFilenameFromHeader(response.headers) || 'data-export.csv';
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          link.click();
          URL.revokeObjectURL(url);
          return of(undefined);
        }),
      );
  }

  private getFilenameFromHeader(headers: HttpHeaders): string | null {
    const contentDisposition = headers.get('content-disposition');
    if (contentDisposition) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
        contentDisposition,
      );
      if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
      }
    }
    return null;
  }
}
